export const busSeats = [
  /* Lower Deck */
  { seatNum: "L1", type: "lowerdeck", isBooked: false },
  { seatNum: "L2", type: "lowerdeck", isBooked: false },
  { seatNum: "L3", type: "lowerdeck", isBooked: true },
  { seatNum: "L4", type: "lowerdeck", isBooked: false },
  { seatNum: "L5", type: "lowerdeck", isBooked: false },
  { seatNum: "L6", type: "lowerdeck", isBooked: false },
  { seatNum: "L7", type: "lowerdeck", isBooked: false },
  { seatNum: "L8", type: "lowerdeck", isBooked: false },
  { seatNum: "L9", type: "lowerdeck", isBooked: false },
  { seatNum: "L10", type: "lowerdeck", isBooked: false },
  { seatNum: "L11", type: "lowerdeck", isBooked: false },
  { seatNum: "L12", type: "lowerdeck", isBooked: false },
  { seatNum: "L13", type: "lowerdeck", isBooked: true },
  { seatNum: "L14", type: "lowerdeck", isBooked: false },
  { seatNum: "L15", type: "lowerdeck", isBooked: false },
  { seatNum: "L16", type: "lowerdeck", isBooked: false },
  { seatNum: "L17", type: "lowerdeck", isBooked: false },
  { seatNum: "L18", type: "lowerdeck", isBooked: false },
  { seatNum: "L19", type: "lowerdeck", isBooked: false },
  { seatNum: "L20", type: "lowerdeck", isBooked: false },
  /* Upper Deck */
  { seatNum: "U1", type: "upperdeck", isBooked: false },
  { seatNum: "U2", type: "upperdeck", isBooked: false },
  { seatNum: "U3", type: "upperdeck", isBooked: false },
  { seatNum: "U4", type: "upperdeck", isBooked: false },
  { seatNum: "U5", type: "upperdeck", isBooked: true },
  { seatNum: "U6", type: "upperdeck", isBooked: false },
  { seatNum: "U7", type: "upperdeck", isBooked: false },
  { seatNum: "U8", type: "upperdeck", isBooked: false },
  { seatNum: "U9", type: "upperdeck", isBooked: false },
  { seatNum: "U10", type: "upperdeck", isBooked: true },
  { seatNum: "U11", type: "upperdeck", isBooked: false },
  { seatNum: "U12", type: "upperdeck", isBooked: false },
  { seatNum: "U13", type: "upperdeck", isBooked: false },
  { seatNum: "U14", type: "upperdeck", isBooked: false },
  { seatNum: "U15", type: "upperdeck", isBooked: false },
  { seatNum: "U16", type: "upperdeck", isBooked: false },
  { seatNum: "U17", type: "upperdeck", isBooked: false },
  { seatNum: "U18", type: "upperdeck", isBooked: false },
  { seatNum: "U19", type: "upperdeck", isBooked: false },
  { seatNum: "U20", type: "upperdeck", isBooked: false },
];
